import Script from 'next/script';

type Props = {
  currentLocale: string;
  config?: {
    [locale: string]: {
      id: string;
      prefix?: string;
    };
  };
};

const HappyCartScript = ({ currentLocale, config }: Props) => {
  // If the config is not present or the current locale is not present in the config, don't load the script
  if (!config || !config[currentLocale]) {
    return null;
  }

  return <Script src="https://cdn.happycart.io/happycart.js" strategy="lazyOnload" />;
};

export default HappyCartScript;
